"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHART_WEIGHT_CLASS_COLORS = exports.chartTimepointColor = exports.CHART_TIMEPOINT_COLORS = exports.CHART_BRAND_COLORS = void 0;
/** Sampled from public/gpfits-logo.png. */
exports.CHART_BRAND_COLORS = {
    navy: "#0B2A40", // "G"
    blue: "#1D415A", // "P"
    sand: "#BCAF95", // "Fit"
    steel: "#53798F", // "S"
};
/**
 * Timepoints T1..T8 (fixed order, then repeated). T1-T3 are the brand hues
 * (navy, champagne gold, steel blue) made more saturated so that bars stay
 * apart; T4-T8 are brand-compatible accents. Neighbours (Tk, Tk+1) are
 * >= 7.9 OKLab ΔE apart under deuteranopia/protanopia/tritanopia.
 */
exports.CHART_TIMEPOINT_COLORS = [
    "#1A5C96", // T1 brand navy
    "#B8841C", // T2 brand gold ("Fit")
    "#4FA3D1", // T3 brand steel blue ("S")
    "#B4492F", // T4 terracotta
    "#8A63B8", // T5 violet
    "#3E9A5A", // T6 green
    "#C6609A", // T7 rose
    "#6E7F1E", // T8 olive
];
/** Colour by timepoint key ("T3" keeps its colour when T1 is filtered out). */
const chartTimepointColor = (key) => exports.CHART_TIMEPOINT_COLORS[(Math.max(1, Number(key.slice(1)) || 1) - 1) % exports.CHART_TIMEPOINT_COLORS.length];
exports.chartTimepointColor = chartTimepointColor;
/**
 * Stack colours: light steel blue (UG), green (NG), then brand gold to dark
 * red (ÜG -> EA). Neighbouring segments are >= 9 OKLab ΔE apart under all
 * three colour vision deficiencies.
 */
exports.CHART_WEIGHT_CLASS_COLORS = {
    UNDERWEIGHT: "#5AA6DE",
    NORMAL: "#3E9A5A",
    OVERWEIGHT: "#D9A93F",
    OBESE: "#C4652B",
    EXTREME_OBESE: "#8C2A1C",
};
